export const COMPANY = {
  name: "TEKNO ŞURA",
  subtitle: "AKINSOFT ŞANLIURFA BÖLGE BAYİ",
  slogan: "İşletmenizin Dijital Dönüşüm Ortağı",
  heroText:
    "İşletmenizin dijital dönüşümünü güvenilir AKINSOFT çözümleriyle hızlandırıyoruz.",
  phone: "+90 554 171 53 33",
  phoneRaw: "+905541715333",
  whatsapp: "905541715333",
  email: "teknosura@gmail.com",
  address: "Yenişehir, Recep Tayyip Erdoğan Blv. 43/B, 63300 Haliliye/Şanlıurfa",
  hours: "Hafta içi 08:00 – 18:00",
  mapEmbed:
    "https://www.google.com/maps?q=Recep+Tayyip+Erdo%C4%9Fan+Blv.+43%2FB+Haliliye+%C5%9Eanl%C4%B1urfa&output=embed",
  mapLink: "https://share.google/ecn6kuXtZOYTZKXDh",
  siteUrl: "https://teknosura.com",
  altUrl: "https://www.akinssoftsanliurfabolge.com",
  seoDescription:
    "AKINSOFT Şanlıurfa Bölge Bayisi TEKNO ŞURA — Wolvox ERP, ön muhasebe, POS, restoran otomasyonu, e-Fatura, e-Arşiv, stok takip, cari hesap, bulut çözümleri ve teknik servis. Şanlıurfa'nın güvenilir AKINSOFT yetkili bayisi.",
};

export const NAV_LINKS = [
  { label: "Ana Sayfa", href: "#hero" },
  { label: "Hakkımızda", href: "#hakkimizda" },
  { label: "Yazılımlar", href: "#yazilimlar", mega: "software" },
  { label: "Hizmetler", href: "#hizmetler", mega: "services" },
  { label: "Sosyal Medya", href: "#sosyal-medya" },
  { label: "Referanslarımız", href: "#referanslar", mega: "refs" },
  { label: "Blog", href: "#blog" },
  { label: "İletişim", href: "#iletisim" },
];

export const MOBILE_APPS = [
  {
    key: "patron-ekrani",
    badge: "Bize Özel Yazılım",
    icon: "LineChart",
    title: "Patron Ekranı",
    tagline: "İşletmeniz cebinizde, veriler canlı.",
    desc: "AKINSOFT'tan gelen anlık ve canlı verilerle işletmenizin nabzını nerede olursanız olun tutun. Kâr/zarar analizinden çek-senet durumuna kadar tüm kritik bilgiler tek dokunuşta.",
    features: [
      "Anlık kâr/zarar ve ciro analizi",
      "Çek & senet takibi ve vade uyarıları",
      "Canlı stok, cari ve kasa durumu",
      "AKINSOFT ile %100 gerçek zamanlı senkron",
    ],
    accent: "orange",
  },
  {
    key: "stok-sayim",
    badge: "Kendi Geliştirdiğimiz Modül",
    icon: "ScanLine",
    title: "Mobil Stok Sayım",
    tagline: "Sayım saatlerini dakikalara indirin.",
    desc: "Kendi bünyemizde kodladığımız mobil stok sayım modülü ile depo sayımlarınızı telefonunuzla, barkod okutarak hızlıca tamamlayın. Sonuçlar anında AKINSOFT'a işlenir.",
    features: [
      "Telefonla barkod okutarak hızlı sayım",
      "Anlık AKINSOFT stok senkronizasyonu",
      "Çoklu depo ve ekip desteği",
      "Sayım farkı raporu ve doğrulama",
    ],
    accent: "green",
  },
];


export const STATS = [
  { value: 5, suffix: " Bin+", label: "Kurumsal Müşteri" },
  { value: 30, suffix: "+", label: "Yıllık Deneyim" },
  { value: 50000, suffix: "+", label: "Kurulum", raw: "5 Bin+" },
  { value: 7, suffix: "/24", label: "Teknik Destek", raw: "7/24" },
];

export const SERVICES = [
  {
    icon: "Cpu",
    title: "AKINSOFT Wolvox ERP",
    desc: "Uçtan uca kurumsal kaynak planlaması ile tüm süreçlerinizi tek çatı altında yönetin.",
    long: "Wolvox ERP; muhasebe, stok, üretim, satış ve insan kaynaklarını tek bir platformda birleştirir. Departmanlar arası veri kopukluğunu ortadan kaldırır, gerçek zamanlı raporlarla doğru kararlar almanızı sağlar.",
    benefits: [
      "Tüm departmanlar tek ekranda, anlık senkron",
      "Gerçek zamanlı kâr/zarar ve stok raporları",
      "Yetkili bayi güvencesiyle orijinal lisans",
      "Yerinde kurulum ve personel eğitimi dahil",
    ],
  },
  {
    icon: "Calculator",
    title: "Ön Muhasebe & Ticari",
    desc: "Cari, stok, fatura ve kasa yönetimini kusursuz takip eden ticari yazılım çözümleri.",
    long: "Cari hesaplarınızı, çek-senet takibinizi ve kasa-banka hareketlerinizi hatasız yönetin. Alacak-borç dengenizi her an görün, tahsilat süreçlerinizi hızlandırın.",
    benefits: [
      "Cari, stok, çek-senet ve kasa tek panelde",
      "Otomatik borç/alacak ve vade takibi",
      "e-Fatura & e-Arşiv ile tam entegrasyon",
      "Kolay kullanım, hızlı adaptasyon",
    ],
  },
  {
    icon: "UtensilsCrossed",
    title: "Restoran & Cafe Otomasyonu",
    desc: "Adisyon, mutfak ekranı ve hızlı servis ile işletmenizi baştan sona dijitalleştirin.",
    long: "Garson terminalinden mutfak ekranına, paket servisten kurye takibine kadar tüm operasyonu dijitalleştirir. Servis süresini kısaltır, sipariş hatalarını sıfıra indirir.",
    benefits: [
      "Tablet/terminal ile anlık sipariş girişi",
      "Mutfak ekranı (KDS) ile sıralı üretim",
      "Paket servis, kurye ve masa yönetimi",
      "Gün sonu satış ve yoğunluk raporları",
    ],
  },
  {
    icon: "ScanBarcode",
    title: "Barkod & POS Sistemleri",
    desc: "Hızlı satış, barkodlu stok ve entegre POS terminalleriyle kesintisiz satış deneyimi.",
    long: "Perakendede hız ve doğruluk esastır. Barkodlu hızlı satış, POS terminali entegrasyonu ve anlık stok senkronizasyonu ile kasada bekleme sürelerini en aza indirin.",
    benefits: [
      "Barkodlu hızlı satış ekranı",
      "POS cihazları ile tam entegrasyon",
      "Anlık stok düşümü ve fiyat yönetimi",
      "Çoklu şube ve kasa desteği",
    ],
  },
  {
    icon: "FileCheck2",
    title: "e-Dönüşüm Çözümleri",
    desc: "e-Fatura, e-Arşiv ve e-İrsaliye süreçlerinizi yasal mevzuata tam uyumlu yönetin.",
    long: "e-Fatura, e-Arşiv ve e-İrsaliye süreçlerinizi GİB mevzuatına tam uyumlu şekilde yönetiyoruz. Kağıt maliyetinden kurtulun, arşivleme derdine son verin.",
    benefits: [
      "GİB mevzuatına tam uyum",
      "Muhasebe programınızdan tek tıkla fatura",
      "Otomatik arşivleme ve raporlama",
      "Mali mühür/e-imza başvuru desteği",
    ],
  },
  {
    icon: "Cloud",
    title: "Bulut Çözümleri",
    desc: "Verilerinize her yerden güvenle erişin, altyapı derdi olmadan çalışmaya devam edin.",
    long: "Verileriniz güvenli veri merkezlerinde barınır; ofis, ev veya sahadan her cihazla erişebilirsiniz. Donanım yatırımı ve yedekleme derdi olmadan kesintisiz çalışın.",
    benefits: [
      "Her yerden, her cihazdan erişim",
      "Otomatik yedekleme ve veri güvenliği",
      "Donanım maliyeti olmadan ölçeklenme",
      "7/24 izleme ve uzaktan destek",
    ],
  },
  {
    icon: "Wrench",
    title: "Teknik Servis & Kurulum",
    desc: "Yerinde kurulum, bakım-destek ve sunucu yönetimiyle kesintisiz operasyon.",
    long: "Uzman ekibimiz yazılım ve donanım kurulumundan periyodik bakıma kadar yanınızda. Sorun çıkmadan önleyici bakım, sorun çıkarsa hızlı müdahale.",
    benefits: [
      "Yerinde kurulum ve konfigürasyon",
      "Periyodik bakım ve önleyici kontrol",
      "Sunucu kurulumu ve yönetimi",
      "Uzaktan ve yerinde hızlı müdahale",
    ],
  },
  {
    icon: "ShieldCheck",
    title: "Ağ & Kamera Sistemleri",
    desc: "İşletmenizin ağ altyapısını ve güvenlik kamerası sistemlerini profesyonelce kuruyoruz.",
    long: "Kesintisiz internet ve güvenli bir ağ altyapısı, dijital operasyonun temelidir. Profesyonel ağ kurulumu ve HD güvenlik kamerası sistemleriyle işletmenizi koruyoruz.",
    benefits: [
      "Yapılandırılmış kablolama ve ağ kurulumu",
      "HD/IP güvenlik kamerası sistemleri",
      "Uzaktan izleme ve kayıt çözümleri",
      "Güvenlik duvarı ve erişim yönetimi",
    ],
  },
];

export const WHY_US = [
  { icon: "BadgeCheck", title: "Yetkili AKINSOFT Bayisi" },
  { icon: "MapPin", title: "Yerinde Kurulum" },
  { icon: "MonitorSmartphone", title: "Uzaktan Destek" },
  { icon: "KeyRound", title: "Orijinal Lisans" },
  { icon: "Headset", title: "7/24 Teknik Servis" },
  { icon: "Users", title: "Uzman Kadro" },
  { icon: "Zap", title: "Hızlı Çözüm" },
  { icon: "TrendingUp", title: "Sürekli Gelişim" },
];

export const SOFTWARE_CATEGORIES = [
  { key: "all", label: "Tümü" },
  { key: "erp", label: "ERP" },
  { key: "muhasebe", label: "Muhasebe" },
  { key: "pos", label: "POS" },
  { key: "restaurant", label: "Restaurant" },
  { key: "bulut", label: "Bulut" },
  { key: "edonusum", label: "e-Dönüşüm" },
];

export const SOFTWARE = [
  {
    category: "erp",
    tag: "ERP",
    icon: "Layers",
    title: "AKINSOFT Wolvox ERP",
    desc: "Üretimden sevkiyata, muhasebeden İK'ya tüm süreçleri yöneten kurumsal platform.",
    benefits: ["Tek platformda tüm departmanlar", "Gerçek zamanlı üretim & stok takibi", "Detaylı finansal raporlama", "Yetkili bayi + orijinal lisans"],
    image:
      "https://images.unsplash.com/photo-1782094673136-5198a372980c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBicmlnaHQlMjBzZXJ2ZXIlMjByb29tfGVufDB8fHx8MTc4NDM4NDcwOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    category: "muhasebe",
    tag: "Muhasebe",
    icon: "Calculator",
    title: "Ön Muhasebe Paketi",
    desc: "Cari hesap, stok, çek-senet ve kasa takibini tek ekrandan yönetin.",
    benefits: ["Cari & stok anlık kontrol", "Çek-senet ve vade takibi", "e-Fatura/e-Arşiv entegrasyonu", "Kolay kullanım, hızlı kurulum"],
    image:
      "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwb2ZmaWNlJTIwYnVzaW5lc3MlMjBtZWV0aW5nfGVufDB8fHx8MTc4NDM4NDcwOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    category: "pos",
    tag: "POS",
    icon: "ScanBarcode",
    title: "Hızlı Satış & Barkod",
    desc: "Perakende için barkodlu hızlı satış, POS entegrasyonu ve stok senkronizasyonu.",
    benefits: ["Barkodlu hızlı satış ekranı", "POS cihaz entegrasyonu", "Anlık stok düşümü", "Çoklu şube & kasa desteği"],
    image:
      "https://images.pexels.com/photos/12935065/pexels-photo-12935065.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    category: "restaurant",
    tag: "Restaurant",
    icon: "UtensilsCrossed",
    title: "Restoran & Cafe Otomasyonu",
    desc: "Adisyon, mutfak ekranı, kurye ve paket servis yönetimi tek çözümde.",
    benefits: ["Terminal ile anlık sipariş", "Mutfak ekranı (KDS)", "Paket servis & kurye takibi", "Gün sonu satış raporları"],
    image:
      "https://images.unsplash.com/photo-1758519289714-519a9d9b96e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjByZXN0YXVyYW50JTIwY2FmZSUyMHBvaW50JTIwb2YlMjBzYWxlfGVufDB8fHx8MTc4NDM4NDcwOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    category: "bulut",
    tag: "Bulut",
    icon: "Cloud",
    title: "AKINSOFT Bulut",
    desc: "Verileriniz güvenli veri merkezlerinde; her cihazdan, her yerden erişim.",
    benefits: ["Her yerden güvenli erişim", "Otomatik yedekleme", "Donanım maliyeti yok", "7/24 izleme & destek"],
    image:
      "https://images.pexels.com/photos/36522028/pexels-photo-36522028.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    category: "edonusum",
    tag: "e-Dönüşüm",
    icon: "FileCheck2",
    title: "e-Fatura & e-Arşiv",
    desc: "e-Fatura, e-Arşiv ve e-İrsaliye süreçlerinde tam mevzuat uyumu.",
    benefits: ["GİB mevzuatına tam uyum", "Tek tıkla fatura kesimi", "Otomatik arşivleme", "Mali mühür başvuru desteği"],
    image:
      "https://images.unsplash.com/photo-1680992046617-e2e35451bcdb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBicmlnaHQlMjBzZXJ2ZXIlMjByb29tfGVufDB8fHx8MTc4NDM4NDcwOHww&ixlib=rb-4.1.0&q=85",
  },
];

export const REFERENCES = [
  {
    name: "Gülnare Baklava",
    sector: "Gıda",
    image: "/ref-1.png",
    desc: "Geleneksel lezzetini modern yönetimle birleştiren Gülnare Baklava, satış, stok ve cari hesap süreçlerini AKINSOFT ile kontrol altında tutuyor.",
  },
  {
    name: "Trans-El",
    sector: "Elektrik",
    image: "/ref-2.png",
    desc: "Transformatör ve elektrik ekipmanları üretiminde AKINSOFT Wolvox ERP ile üretimden satışa kadar tüm operasyonlarını dijitalleştirdi.",
  },
  {
    name: "MaxiSu Pump & Motor",
    sector: "Sanayi",
    image: "/ref-3.png",
    desc: "Pompa ve motor sektöründe; stok takibi, fatura yönetimi ve teknik servis süreçlerini AKINSOFT çözümleriyle tek çatı altında topluyor.",
  },
  {
    name: "La Foresta Cafe Bistro",
    sector: "Restaurant",
    image: "/ref-4.png",
    desc: "Cafe ve bistro işletmesinde AKINSOFT restoran otomasyonu ve POS çözümleriyle sipariş, adisyon ve muhasebe süreçlerini hızlandırıyor.",
  },
  {
    name: "Bekir Lale Makina",
    sector: "İnşaat",
    image: "/ref-5.png",
    desc: "Hırdavat ve inşaat makinaları sektöründe; cari takip, çek-senet yönetimi ve stok kontrolünü AKINSOFT ile güvenilir şekilde yönetiyor.",
  },
  {
    name: "Teknogap Tarım",
    sector: "Tarım",
    image: "/ref-6.png",
    desc: "Tarım sektöründe faaliyet gösteren Teknogap, satın alma, satış ve mali raporlama süreçlerini AKINSOFT ERP ile verimli hale getirdi.",
  },
  {
    name: "New Natural",
    sector: "Gıda",
    image: "/ref-7.png",
    desc: "Doğal gıda ürünleri üretiminde AKINSOFT ile lot takibi, stok yönetimi ve e-Fatura entegrasyonunu sorunsuz şekilde kullanıyor.",
  },
  {
    name: "Moya Yapı Market",
    sector: "Hırdavat",
    image: "/ref-8.png",
    desc: "Yapı market ve hırdavat perakendesinde POS, stok ve cari hesap yönetimini AKINSOFT çözümleriyle merkezi bir sistemde birleştiriyor.",
  },
  {
    name: "Emsako",
    sector: "Otel Ekipmanları",
    image: "/ref-9.png",
    desc: "Endüstriyel mutfak ve otel ekipmanları sektöründe AKINSOFT ile sipariş takibi, üretim planlama ve muhasebe işlemlerini dijitalleştirdi.",
  },
  {
    name: "Asır Panel",
    sector: "İnşaat",
    image: "/ref-10.png",
    desc: "Panel çözümleri üretiminde AKINSOFT Wolvox ERP ile üretim, satış ve finans süreçlerini tek platformdan yönetiyor.",
  },
  {
    name: "Mutfacto",
    sector: "Otel Ekipmanları",
    image: "/ref-11.png",
    desc: "Endüstriyel mutfak sektöründe; stok, sipariş ve servis yönetimini AKINSOFT ile otomatikleştirerek operasyonel verimliliği artırdı.",
  },
  {
    name: "Yakutsan",
    sector: "Perakende",
    image: "/ref-12.png",
    desc: "Perakende sektöründe faaliyet gösteren Yakutsan, satış noktası ve muhasebe süreçlerini AKINSOFT ile entegre bir yapıya kavuşturdu.",
  },
  {
    name: "Ferat",
    sector: "Sanayi",
    image: "/ref-13.png",
    desc: "Dalgıç pompa üretiminde AKINSOFT ile üretim takibi, stok yönetimi ve satış sonrası servis süreçlerini profesyonel şekilde yönetiyor.",
  },
  {
    name: "Zerga İtriyat",
    sector: "Sağlık",
    image: "/ref-14.png",
    desc: "İtriyat ve sağlık sektöründe; stok takibi, barkod yönetimi ve e-Fatura süreçlerini AKINSOFT çözümleriyle güvenle yürütüyor.",
  },
];

export const BLOG = [
  {
    slug: "e-faturaya-geciste-5-adim",
    title: "e-Fatura'ya Geçişte Bilmeniz Gereken 5 Adım",
    excerpt:
      "2025 mevzuatıyla birlikte e-Fatura zorunluluğu genişledi. İşletmenizi sorunsuz uyumlu hale getirin.",
    date: "12 Şubat 2025",
    readTime: "4 dk okuma",
    author: "Tekno Şura Ekibi",
    category: "e-Dönüşüm",
    image:
      "https://images.unsplash.com/photo-1680992046617-e2e35451bcdb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBicmlnaHQlMjBzZXJ2ZXIlMjByb29tfGVufDB8fHx8MTc4NDM4NDcwOHww&ixlib=rb-4.1.0&q=85",
    content: [
      { type: "p", text: "e-Fatura, kağıt fatura ile aynı hukuki niteliğe sahip, elektronik ortamda düzenlenen ve saklanan faturadır. 2025 yılı itibarıyla ciro sınırlarının düşürülmesiyle birlikte çok daha fazla işletme e-Fatura kapsamına girdi. Geçiş sürecini doğru planlamak, hem cezai yaptırımlardan korunmanızı hem de operasyonel verimlilik kazanmanızı sağlar." },
      { type: "h", text: "1. Mükellefiyet Durumunuzu Kontrol Edin" },
      { type: "p", text: "İlk adım, işletmenizin cirosu ve faaliyet alanı itibarıyla e-Fatura zorunluluğu kapsamında olup olmadığını netleştirmektir. Zorunlu olmasanız bile gönüllü geçiş, tedarikçi ve müşteri ilişkilerinizde önemli bir avantaj sağlar." },
      { type: "h", text: "2. Mali Mühür veya e-İmza Temin Edin" },
      { type: "p", text: "e-Fatura düzenleyebilmek için tüzel kişiler mali mühür, şahıs firmaları ise mali mühür veya e-imza kullanır. Bu adım genellikle en çok zaman alan kısımdır; erkenden başvurmanızı öneririz." },
      { type: "h", text: "3. Doğru Entegratörü Seçin" },
      { type: "p", text: "GİB portalı, özel entegrasyon veya entegratör yöntemlerinden birini seçmeniz gerekir. AKINSOFT Wolvox ile tam entegre çalışan çözümlerimiz sayesinde faturalarınızı doğrudan muhasebe programınızdan kesebilirsiniz." },
      { type: "h", text: "4. Muhasebe Yazılımınızı Entegre Edin" },
      { type: "p", text: "Tekno Şura olarak Wolvox ERP kurulumunuzu e-Dönüşüm süreçlerinize bağlıyor; stok, cari ve fatura akışının tek ekrandan yönetilmesini sağlıyoruz. Böylece manuel veri girişi ve hata riski ortadan kalkar." },
      { type: "h", text: "5. Ekibinizi Eğitin" },
      { type: "p", text: "Teknoloji kadar, onu kullanan ekip de önemlidir. Kurulum sonrası düzenlediğimiz yerinde eğitimlerle personelinizin sisteme hızla adapte olmasını sağlıyoruz." },
      { type: "quote", text: "Doğru planlanmış bir e-Dönüşüm geçişi, sadece yasal bir zorunluluk değil; işletmenizin dijital olgunluğunu artıran bir fırsattır." },
    ],
  },
  {
    slug: "wolvox-erp-stok-maliyeti",
    title: "Wolvox ERP ile Stok Maliyetlerinizi Nasıl Düşürürsünüz?",
    excerpt:
      "Doğru kurgulanmış bir ERP, stok devir hızını artırır ve ölü stoğu azaltır. İşte pratik ipuçları.",
    date: "28 Ocak 2025",
    readTime: "5 dk okuma",
    author: "Tekno Şura Ekibi",
    category: "ERP",
    image:
      "https://images.pexels.com/photos/36522028/pexels-photo-36522028.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    content: [
      { type: "p", text: "Stok, birçok işletme için hem en büyük yatırım kalemi hem de en büyük risk alanıdır. Fazla stok nakit akışını kilitlerken, eksik stok satış kaybına yol açar. AKINSOFT Wolvox ERP, bu dengeyi veriye dayalı olarak kurmanıza yardımcı olur." },
      { type: "h", text: "Gerçek Zamanlı Stok Görünürlüğü" },
      { type: "p", text: "Wolvox ile tüm depo ve şubelerinizdeki stok hareketlerini anlık olarak izleyebilirsiniz. Hangi ürünün ne kadar sürede tükendiğini görerek doğru zamanda doğru miktarda sipariş verirsiniz." },
      { type: "h", text: "Minimum ve Maksimum Stok Seviyeleri" },
      { type: "p", text: "Her ürün için kritik stok seviyeleri tanımlayarak otomatik uyarılar alırsınız. Bu sayede ne ölü stok birikir ne de raflar boş kalır." },
      { type: "h", text: "ABC Analizi ile Önceliklendirme" },
      { type: "p", text: "Cironuzun büyük kısmını oluşturan ürünleri (A grubu) belirleyip bu ürünlere odaklanırsınız. Düşük devir hızına sahip ürünlerde ise kampanya veya tasfiye stratejileri geliştirebilirsiniz." },
      { type: "quote", text: "Stok yönetiminde sezgi değil, veri kazandırır. Doğru ERP kurgusu, kârlılığınızı doğrudan etkiler." },
      { type: "p", text: "Tekno Şura olarak yalnızca yazılımı kurmuyor; işletmenizin ihtiyacına göre stok kartlarını, raporları ve uyarı mekanizmalarını sizin için yapılandırıyoruz." },
    ],
  },
  {
    slug: "restoran-dijital-adisyon",
    title: "Restoranlar İçin Dijital Adisyon Devrimi",
    excerpt:
      "Mutfak ekranı ve hızlı adisyon ile servis süresini kısaltıp müşteri memnuniyetini artırın.",
    date: "15 Ocak 2025",
    readTime: "3 dk okuma",
    author: "Tekno Şura Ekibi",
    category: "Restaurant",
    image:
      "https://images.unsplash.com/photo-1758519289714-519a9d9b96e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjByZXN0YXVyYW50JTIwY2FmZSUyMHBvaW50JTIwb2YlMjBzYWxlfGVufDB8fHx8MTc4NDM4NDcwOHww&ixlib=rb-4.1.0&q=85",
    content: [
      { type: "p", text: "Yoğun bir restoran veya cafede saniyeler önemlidir. Kağıt adisyonla çalışan işletmelerde sipariş hataları, geç servis ve mutfak-salon iletişim kopukluğu sık yaşanır. Dijital adisyon sistemleri bu sorunları kökten çözer." },
      { type: "h", text: "Garson Elinde Anında Sipariş" },
      { type: "p", text: "Garson, siparişi el terminali veya tabletten girdiği anda sipariş doğrudan mutfak ekranına düşer. Böylece koşuşturma ve yanlış anlaşılma ortadan kalkar." },
      { type: "h", text: "Mutfak Ekranı (KDS) ile Sıralı Üretim" },
      { type: "p", text: "Mutfak, gelen siparişleri öncelik sırasına göre görür; hangi masanın ne kadar beklediğini takip eder. Servis süresi kısalır, müşteri memnuniyeti artar." },
      { type: "h", text: "Hızlı Kasa ve Raporlama" },
      { type: "p", text: "Gün sonunda hangi ürünün ne kadar sattığını, hangi saatlerin yoğun olduğunu tek tıkla raporlarsınız. Bu veriler menü ve personel planlamanızı iyileştirir." },
      { type: "quote", text: "Dijital adisyon; sadece hız değil, aynı zamanda kontrol ve kârlılık demektir." },
    ],
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Yetkili Bayi Güvencesi",
    body: "AKINSOFT Şanlıurfa Bölge Bayisi olarak orijinal lisans ve resmi destek sunuyoruz.",
  },
  {
    no: "02",
    title: "Kurulumdan Eğitime",
    body: "Yazılımı kurmakla kalmıyor, ekibinizi eğitip verimli kullanmanızı sağlıyoruz.",
  },
  {
    no: "03",
    title: "Kesintisiz Operasyon",
    body: "7/24 teknik servis ve uzaktan destek ile işletmeniz hiçbir zaman durmaz.",
  },
];

export const SOCIAL_MEDIA_SERVICES = [
  {
    icon: "Camera",
    title: "Profesyonel Çekim Hizmetleri",
    desc: "İşletmeniz için sinema kalitesinde fotoğraf ve video çekimleri.",
    long: "Profesyonel ekipmanlarımız ve uzman ekibimizle işletmenizi en iyi şekilde yansıtan görsel içerikler üretiyoruz. Ürün çekimlerinden kurumsal tanıtım filmlerine, drone çekimlerinden reklam videolarına kadar tüm ihtiyaçlarınızı karşılıyoruz.",
    benefits: [
      "Ürün çekimleri ve kurumsal tanıtım filmleri",
      "Drone ile havadan çekimler",
      "Reklam ve sosyal medya videoları",
      "4K kalitesinde profesyonel kurgu",
    ],
    accent: "orange",
  },
  {
    icon: "Share2",
    title: "Aylık Sosyal Medya Yönetimi",
    desc: "Instagram, Facebook, TikTok ve LinkedIn'de profesyonel yönetim.",
    long: "Sosyal medya hesaplarınızı başından sonuna kadar yönetiyoruz. İçerik üretiminden görsel tasarıma, düzenli paylaşımlardan etkileşim yönetimine kadar tüm süreçleri profesyonelce üstleniyor, aylık performans raporlarıyla sonuçları birlikte değerlendiriyoruz.",
    benefits: [
      "İçerik üretimi ve görsel tasarım",
      "Düzenli paylaşım ve story yönetimi",
      "Etkileşim ve topluluk yönetimi",
      "Aylık performans raporları",
    ],
    accent: "purple",
  },
  {
    icon: "Search",
    title: "Google'da Öne Çıkma",
    desc: "Google aramalarında ve Google Haritalar'da üst sıralarda olun.",
    long: "Google aramalarında ve Google Haritalar'da üst sıralarda yer alarak potansiyel müşterilerinize daha kolay ulaşın. SEO çalışmalarından Google My Business optimizasyonuna kadar tüm dijital görünürlük süreçlerinizi yönetiyor, düzenli sıralama raporlarıyla ilerlemeyi birlikte takip ediyoruz.",
    benefits: [
      "SEO çalışmaları ve anahtar kelime analizi",
      "Google My Business optimizasyonu",
      "Yerel arama ve harita kaydı",
      "Düzenli sıralama raporları",
    ],
    accent: "green",
  },
];

export const SOCIAL_MEDIA_PROCESS = [
  { step: "01", title: "Analiz & Strateji", desc: "Markanızı, rakipleri ve hedef kitlenizi analiz eder, size özel strateji oluştururuz." },
  { step: "02", title: "İçerik Üretimi", desc: "Profesyonel çekim ve tasarım ekibimizle etkileyici içerikler üretiriz." },
  { step: "03", title: "Yayın & Yönetim", desc: "İçerikleri düzenli yayınlar, etkileşimi yönetir, topluluğunuzu büyütürüz." },
  { step: "04", title: "Raporlama", desc: "Performans verilerini analiz eder, stratejiyi sürekli optimize ederiz." },
];

export const SERVICE_OPTIONS = [
  "AKINSOFT Wolvox ERP",
  "Ön Muhasebe / Ticari Yazılım",
  "Restoran & Cafe Otomasyonu",
  "Barkod & POS Sistemleri",
  "e-Dönüşüm (e-Fatura / e-Arşiv)",
  "Bulut Çözümleri",
  "Teknik Servis & Kurulum",
  "Ağ & Kamera Sistemleri",
  "Sosyal Medya & Dijital Pazarlama",
  "Profesyonel Çekim Hizmetleri",
  "Google SEO & Öne Çıkma",
  "Diğer / Danışmanlık",
];
